import React from 'react';

const Footer = () => {
 return(
  <footer>
   <p>Made with  <i class="fa fa-heart-o"></i> by <a href="https://ohis.netlify.app" target="_blank" className="ohis" >ohis</a></p>
  </footer>
 )
}

export default Footer;